<template>
  <div class="header">
    <!-- 伸缩按钮 -->
    <!-- <div class="nav-icon" @click="toggleSideBar" style="color: #ffffff;">
      <Icon type="navicon-round"></Icon>
    </div> -->
    <!-- 伸缩按钮 /-->
    <slot name='left'></slot>
    <!--是否全屏  -->
    <div class="expand-screen"  style="color: #3A3A3A;">
      <!--<Icon type="android-expand" v-if="!screen"></Icon>-->
      <!--<Icon type="android-contract" v-if="screen"></Icon>-->
    </div>
    <!--是否全屏  /-->
    <!-- 消息类按钮 -->
    <div class="msg-group-box">
      <slot name='msg-icon'></slot>
      <slot name='right'></slot>
    </div>

    <!-- 消息类按钮 /-->
  </div>
</template>

<script>
  export default {
    name: 'THeader',
    data () {
      return {
        screen: false,
        nowScreen:0,
        nowChange:1,
      }
    },
    mounted: function() {
      window.onresize = () => {
        return (() => {
          this.nowScreen = this.nowScreen + this.nowChange
          if (this.nowScreen % 3 == 0 && this.screen == true) {
            this.nowScreen = 0
            this.screen = false
          }
        })()
      }
    },
    methods: {
      toggleSideBar () {
        this.$store.dispatch('ToggleSideBar')
      },
      toggleScreen () {
        if (!this.screen) {
          var docElm = document.documentElement
          if (docElm.requestFullscreen) {
            docElm.requestFullscreen()
          } else if (docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen()
          } else if (docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen()
          } else if (docElm.msRequestFullscreen) {
            docElm.msRequestFullscreen()
          } else {
            this.$Message.error({content: this.$t('yd.error.updatebrowser'), duration: 3})
          }
          this.screen = true
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen()
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen()
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
          } else {
            this.$Message.error({content: this.$t('yd.error.updatebrowser'), duration: 3})
          }
          this.screen = false
        }
      }
    }
  }
</script>
<style>
  .msg-group-box {
    float: right
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// THeader.vue?dce46322